<div class="container-fluid">
  <app-topbar></app-topbar>
  <div class="content-container">
    <app-navbar></app-navbar>

    <div class="main-content">
      <div class="content">
        <!-- Cards de Bootstrap -->
        <div id="cards-container" class="row">
          <!--         <div id="card-Reportes" class="col-lg-3 col-md-6 mb-4">
            <div class="card" (click)="abrirVentanaReporte()">
              <div class="card-body card-roja">
                <h5 class="card-title">Reporte de Titulares activos sin DJ</h5>
                <p class="card-text">
                  Generar reporte de titulares activos sin declaración jurada en
                  PDF.
                </p>
              </div>
            </div>
          </div> -->

          <div id="card-Planes" class="col-lg-3 col-md-6 mb-4">
            <div
              class="card card-versiones"
              routerLink="/planes"
              style="cursor: pointer"
            >
              <div class="card-body">
                <h5 class="card-title">Planes</h5>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th class="text-end">Desde</th>
                        <th class="text-end">Hasta</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let plan of planes">
                        <td>{{ plan.descripcion }}</td>
                        <td class="text-end">
                          {{
                            plan.importeDesde | currency : "ARS" : "" : "1.2-2"
                          }}
                        </td>
                        <td class="text-end">
                          {{
                            plan.importeHasta | currency : "ARS" : "" : "1.2-2"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
            id="card-NuevosCambios"
            class="col-lg-9 col-md-12 mb-4"
            *ngIf="mensajeCambiosNuevos"
          >
            <div class="card border-info">
              <div
                class="card-header bg-info text-white d-flex align-items-center justify-content-between"
              >
                <h5 class="card-title mb-0">Nuevos cambios</h5>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-light"
                  (click)="toggleNuevosCambios()"
                  [attr.aria-expanded]="nuevosCambiosExpandido"
                  aria-controls="nuevosCambiosContenido"
                >
                  {{ nuevosCambiosExpandido ? "Ocultar" : "Ver detalles" }}
                </button>
              </div>
              <div
                id="nuevosCambiosContenido"
                class="card-body position-relative"
                [class.card-body-collapsed]="!nuevosCambiosExpandido"
              >
                <div
                  class="nuevos-cambios-contenido"
                  [class.nuevos-cambios-contenido--colapsado]="
                    !nuevosCambiosExpandido
                  "
                >
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      <strong>Fechas en Gestión Personas:</strong>
                      <br />
                      Al cargar o editar una persona, los campos de fecha de
                      nacimiento y fecha de venta permiten escribir y formatean
                      automáticamente la entrada en el formato DIA/MES/AÑO.
                      <br />
                      <br />
                      <h5>Se permite:</h5>
                      - Ingresar 7/7/2025 y el sistema lo convierte a 07/07/2025
                      <br />
                      - Escribir 3 dígitos seguidos (por ejemplo, 070) y el
                      sistema lo convierte a 07/0.
                    </li>
                    <li class="list-group-item">
                      <strong>Herencia de datos titular:</strong>
                      <br />
                      Al cargar un titular y luego un adherente, o agregar un
                      adherente al seleccionar un titular, se precargan los
                      siguientes datos del titular: Domicilio, Teléfono,
                      Provincia, Localidad, Nacionalidad, Fecha venta y
                      Vendedor.
                    </li>
                    <li class="list-group-item">
                      <strong>Inhabilitación:</strong>
                      <br />
                      Por motivos de cambio de lógica, quedan temporalmente
                      eliminados los atajos rápidos de "Exportar a Gestos" y
                      "Reporte de Titulares activos sin DJ".
                    </li>
                    <li class="list-group-item">
                      <strong>Validaciones:</strong>
                      <br />
                      Agregamos validaciones al cargar personas:
                      <br />
                      - CUIL debe tener 11 dígitos y ser numérico
                      <br />
                      - DNI debe tener 8 dígitos y ser numérico
                      <br />
                      - Teléfono debe tener mínimo 8 dígitos y ser numérico
                      <br />
                      - Fecha de nacimiento no puede exceder la fecha actual y
                      debe ser válida
                    </li>
                  </ul>
                </div>
                <div
                  *ngIf="!nuevosCambiosExpandido"
                  class="nuevos-cambios-overlay"
                >
                  <span class="text-muted small"
                    >Haz clic en "Ver detalles" para continuar leyendo.</span
                  >
                </div>
              </div>
              <div class="card-footer bg-transparent">
                <small class="text-muted"
                  >Última actualización: 13 de Noviembre 2025</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de facturas pendientes -->
<app-modal-facturas-pendientes></app-modal-facturas-pendientes>
